var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSubtitles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.3 2A2.7 2.7 0 0 1 20 4.7v10.6a2.7 2.7 0 0 1-2.7 2.7H2.7A2.7 2.7 0 0 1 0 15.3V4.7A2.7 2.7 0 0 1 2.7 2zm0 2H2.7a.7.7 0 0 0-.7.7v10.6a.7.7 0 0 0 .7.7h14.6a.7.7 0 0 0 .7-.7V4.7a.7.7 0 0 0-.7-.7M11 12a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Zm4 0a1 1 0 0 1 0 2h-1a1 1 0 0 1 0-2ZM8 9a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2Zm7 0a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2Z"
})));
export default SvgIconSubtitles;